import { StackDivider, VStack } from "@chakra-ui/react";
import { KeyFigure } from "src/components/common/key-figure";
import { IRankingData, EnumRankingType } from "src/components/common/ranking/types";
import { useDateTimeFormatter } from "src/hooks/formatters/use-date-time-formatter";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";

interface ICardRankingsType {
    rankings: IRankingData[];
    currency?: string;
}

export const CardRankings = ({ rankings, currency }: ICardRankingsType) => {
    const { formatNumber } = useNumberFormatter();
    const { formatDateShort } = useDateTimeFormatter();

    const getValue = (ranking: IRankingData) => {
        if (ranking.type === EnumRankingType.InvestedCapital) {
            return `${currency} ${formatNumber(ranking.value ?? 0)}`;
        }

        if (ranking.type === EnumRankingType.Date && ranking.date) {
            return `${formatDateShort(ranking.date)}`;
        }

        return undefined;
    };

    return (
        <VStack w="100%" divider={<StackDivider borderColor="gray.100" />} spacing={0}>
            {rankings.map(ranking => (
                <KeyFigure
                    key={ranking.label}
                    h={6}
                    ranking={ranking}
                    value={getValue(ranking)}
                    fontSize="sm"
                    rankingValueFontWeight="bold"
                    hidePoints
                />
            ))}
        </VStack>
    );
};
